import cx from 'classnames'
import { useButton } from '@react-aria/button'
import { ChevronRight } from 'almanac-ui/icons/12'
import { useRef } from 'react'
import Styles from './SectionHeader.module.scss'

import { SectionHeaderProps } from './Types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

const SectionHeader = observer(
  ({
    children,
    label,
    isExpanded = false,
    isExpandable = true,
    onPress,
    inModal,
    inLocationPicker,
    size = 'md',
    forceShowChildren = false,
    ...rest
  }: SectionHeaderProps) => {
    const ref = useRef<HTMLButtonElement>(null)
    const { buttonProps } = useButton({ onPress }, ref)
    const { leftSidebarStore } = useRootStore()
    const { isMobile } = useResponsiveDesign()

    return (
      <div
        className={cx(Styles.root, Styles[size], {
          [Styles.expanded]: isExpanded,
          [Styles.expandable]: isExpandable,
          [Styles.hovered]: leftSidebarStore.isHovered,
          [Styles.inModal]: inModal,
          [Styles.inLocationPicker]: inLocationPicker,
        })}
        {...rest}
      >
        <button {...buttonProps} ref={ref} className={Styles.label}>
          <span className={Styles.text}>{label}</span>
          {isExpandable && <ChevronRight />}
        </button>
        {!isMobile && <div className={Styles.buttons}>{children}</div>}
        {forceShowChildren && <div className={Styles.buttons}>{children}</div>}
      </div>
    )
  },
)

export { SectionHeader }
